import { configureStore, combineReducers } from '@reduxjs/toolkit';

import templateReducer from './_templateSlice';
import companyReducer from './companySlice';
import settingsReducer from './settingsSlice';

const rootReducer = combineReducers({
  template: templateReducer,
  company: companyReducer,
  settings: settingsReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
